// S :::: 이미지 불러오기 :::: S
import VLAZEImage from "../assets/images/instructors/instructors-vlaze.webp";
import WARIImage from "../assets/images/instructors/instructors-wari.webp";
import BUMBLEBImage from "../assets/images/instructors/instructors-bumbleb.webp";
import EUNHYEImage from "../assets/images/instructors/instructors-eunhye.webp";
import BOOBIImage from "../assets/images/instructors/instructors-boobi.webp";
import HONEYBEEImage from "../assets/images/instructors/instructors-honeybee.webp";
import WAANOImage from "../assets/images/instructors/instructors-wanno.webp";
import KYURIImage from "../assets/images/instructors/instructors-kyuri.webp";
import JAEHUNImage from "../assets/images/instructors/instructors-jaehun.webp";
// E :::: 이미지 불러오기 :::: E

// S ::::: 강사진 ::::: S
export const instructorsDetailList = [
  {
    name: "VLAZE",
    genre: "셔플 & 풋워크",
    class: [
      "셔플댄스 지도자 자격과정",
      "목 7:00 PM | 셔플&풋워크 LEVEL.4",
      "목 8:00 PM | 풋워크 테크닉",
      "토 11:00 AM | 셔플&풋워크 LEVEL.4",
      "토 1:00 PM | 셔플&풋워크 LEVEL.3",
      "토 4:00 PM | 풋워크 테크닉",
      "일 11:00 AM | 셔플&풋워크 LEVEL.4",
    ],
    career: [
      "넵튠 댄스스튜디오 대표",
      "IPDIA 국제실용댄스지도자협회 협회장",
      "2025 DDD 페스티벌 공연 및 [넵튠]팀 퍼포먼스 총괄",
      "2025 FOOTWORKSHOP Vol.1 총괄 프로듀싱",
      "엔이원하우스 댄스트레이너",
      "뉴오더 엔터테인먼트 트레이너",
      "어트랙트 엔터테인먼트 댄스트레이너",
      "스타크루ENT 엔터테인먼트 댄스트레이너",
      "LM 엔터테인먼트 댄스트레이너",
      "레인보우ENM 댄스트레이너",
      "안녕뮤직 엔터테인먼트 댄스트레이너",
      "한국예술학교 실용무용 출강",
      "오리엔탈 서울 VOL.6 실용무용대회 심사",
      "아시아희망캠프기구 글로벌오디션 심사",
      "걸그룹 피프티피프티 트레이닝",
      "모델 박윤채 트레이닝",
      "걸스플래닛 참가자 모모코 연습생 트레이닝",
      "다이아 기희현, 예빈 트레이닝",
      "러블리즈 서지수 트레이닝",
      "루나솔라 지안 트레이닝",
      "HUB 효선 비주얼디렉팅 & 트레이닝",
      "슈퍼스타 K4 리틀GOD 트레이닝",
      "MNET 언프리티랩스타2 콘서트",
      "오리엔탈 서울 VOV.6 갈라쇼 초청공연",
      "MNET 언프리티랩스타2 [안수민] 무대 퍼포먼스 연출",
      "KBS 더유닛 [HUB 효선] 퍼포먼스 디렉팅 & 트레이닝",
      "KBS 더유닛 [레드팀] 퍼포먼스 리디렉팅",
      "JTBC 믹스나인 [루이] 퍼포먼스 디렉팅 및 트레이닝",
      "SIWA 국제여성협회 여성의날 댄스퍼포먼스 연출",
      "다수 입시 및 오디션 합격생 배출",
    ],
    instagram: "https://www.instagram.com/vlazeon/",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: VLAZEImage,
  },
  {
    name: "EUN HYE",
    genre: "셔플 / 기초 기본기 / 힙합",
    class: [
      "수 7:00 PM | 셔플 안무",
      "수 8:00 PM | 셔플 LEVEL.1",
      "토 12:00 PM | 셔플 LEVEL.2",
      "토 2:00 PM | 셔플 안무",
      "일 1:00 PM | 셔플&풋워크 LEVEL.3",
    ],
    career: [
      "IPDIA 국제실용댄스지도자협회 강사진/교육위원회",
      "엔이원하우스 댄스트레이너",
      "레인보우ENM 댄스트레이너",
      "Planet8 댄스학원 강사",

      "전) YN 댄스아카데미 강사",
      "전) BK dance 강사",
      "Street all round championship 대상",
      "I’m a dancer vol.4 대상",
      "Up&down vol.2 대상",
      "K-teen 최우수",
      "서울종합예술학교 퍼포먼스 dance battle 우수상",
      "Bring it guest show",
      "Royal straight flush vol.1 guestshow",
      "Show me the passion guestshow",
      "Adrenalin rush vol.2 2nd",
      "현재 다수 학교 및 기관 출강",
    ],
    instagram: "https://www.instagram.com/ehmrzze/",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: EUNHYEImage,
  },
  {
    name: "KYURI",
    genre: "셔플 / KPOP",
    class: [
      "월 7:00 PM | 셔플 LEVEL.1",
      "월 8:00 PM | 셔플 LEVEL.2",
      "수 2:00 PM | 시니어 셔플",
      "목 9:00 PM | 레트로 케이팝",
      "토 10:00 AM | 셔플 LEVEL.1",
    ],
    career: [
      "IPDIA 국제실용댄스지도자협회 강사진",
      "AZ엔터테인먼트 오디션 강사 ",
      "서울스포티 KPOP 강사",
      "서울특별시립청소년수련관  KPOP 강사",
      "한국전력아트센터 자유예술학기 특별 출강 ",
      "서대문구 청소년진로박람회 KPOP 강의 및 멘토",
      "이열치열 콘서트 공연",
      "서울호서예술실용전문학교 Dream Stage 공연",
      "서울호서예술실용전문학교 라운 축제 공연",
      "니가타 show&hac 케이팝 페스티벌 공연",
      "강서 신년 음악회 공연",
      "현재 다수 학교 및 기관 출강 ",
    ],
    instagram: "https://www.instagram.com/tangerine_k_",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: KYURIImage,
  },
  {
    name: "BUMBLE.B",
    genre: "힙합",
    class: ["월 9:00 PM | 힙합 비기너"],
    career: [
      "(현) 정화예대 교수",
      "(현) Beatmix_pro 힙합강사",
      "JPJD 25U Age 1on1 hiphop 2nd winner",
      "Rizz on Battle 2nd winner ",
      "Personality Vol.2 Winner",
      "Untitle Vol.2 2nd Winner",
      "Intro dance 힙합강사",
      "(전) 6xense Dance studio 힙합강사",
      "(전) TS dance studio힙합강사",
      "국민대학교 교양수업 출강",
      "Waacking International 016 GUEST SHOW",
      "모바일 가상현실 연구센터 2016 오프닝 퍼포먼스",
      "Super Teenager Vol.8 GUEST SHOW",
      "로미오-니가없는데' M/V 출연",
      "Mnet스트릿 맨 파이터 뱅크투브라더스 메가크루",
      "MONTHLY EUPHORIA hiphop battle Judge",
      "JPJD 25U Age 1on1 hiphop 2nd winner",
      "Rizz on Battle 2nd winner",
      "2023 Dustyred PARTY Guest Show (Team . MASS EFFECT]",
      "2024 라이트 하우스 댄스 Workshop",
      "2024 청춘뜨락 유스 10n1 Open Style Judge",
      "Artistic Proof Vol.1 WINNER",
      "2024 FeedBack Battle BEST16",
      "2024 Skullab Battles Finalist",
      "2024 JPJD AGE 25U 10N1 2ND WINNER",
      "Naru All Style battle 20n2 BEST8",
      "2024 Turntablism 7 To Smoke 2ND WINNER SDC Battle WINNER",
      "2022 No More Kings BEST8 & MVP",
      "동방배틀 VOL. 19 힙합 부문 WINNER",
      "2019 세종대왕 배틀 WINNER",
      "다수 배틀 수상 경력",
    ],
    instagram: "https://www.instagram.com/bumble.b_/",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: BUMBLEBImage,
  },
  {
    name: "WHATDOWWARI",
    genre: "KPOP / 코레오",
    class: ["케이팝 지도자 자격과정"],
    career: [
      "IPDIA 국제실용댄스지도자협회 강사진/교육위원회",
      "MNH 엔터테인먼트 청하 댄스트레이너",
      "식스오션스 엔터테인먼트 2AM창민 댄스트레이너",
      "크롬 엔터테인먼트 트레이너 및 안무가",
      "네가네트워크 라붐,LC9 트레이너 및 안무가",
      "브라운아이드 걸스 백업",
      "걸그룹 라붐 안무참여 및 디렉팅",
      "걸그룹 크레용팝 안무참여 및 디렉팅",
      "HY 댄스스튜디오 코레오 강사",
      "아임뉴댄스스튜디오 코레오, KPOP 강사",
      "MOVE 댄스스튜디오 홍대점 코레오 강사",
      "코리아갓탤런트1 공연",
      "언프리티랩스타2 콘서트 공연",
      "2018 평창 동계올림픽 폐막식 공연",
      "다수 입시 합격생 배출",
    ],
    instagram: "https://www.instagram.com/whatdowwari/",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: WARIImage,
  },

  {
    name: "JAE HUN",
    genre: "하우스",
    class: ["토 3:00 PM | 하우스 비기너"],
    career: [
      "무브댄스 홍대점 하우스 강사",
      "bibim(비빔) - bad supermario M/V 댄서 참여",
      "문연주 - 잡지마라M/V 댄서 참여",
      "School Attack vol.1 battle side best 4",
      "2025 안무가전 City 디렉터 및 우수안무상 수상",
      "경희대 글로벌미래교육원 실용무용계열  No doubt VOL.7 디렉 및 참여",
      "전 병점 라인업 댄스 앤 휘트니스 학원 코레오 강사",
      "현 춘천아라댄스아카데미 하우스 강사",
    ],
    instagram: "https://www.instagram.com/_jaeh_un_/",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: JAEHUNImage,
  },
  {
    name: "HONEYBEE",
    genre: "브레이킹 / 풋워크",
    class: ["일 12:00 PM | 키즈 풋워크 프로"],
    career: [
      "현) 브레이킹 국가대표 상비군",
      "2025 제 8회 브레이킹 프로젝트 대회 TOP 4 수상",
      "틱톡 MCN 메이저스 브레이킹 댄스 교육 강사",
      "굿앤굿아트비젼 이사 및 천안흥타령춤축제 댄스컬 부문 <연기상> 수상",
      "구로문화재단 고리 문화센터 <브레이킹 댄스팀> 인터뷰",
      "스타코어 엔터테인먼트 브레이킹 강사",
      "SKT ifland(이프랜드) <브레이킹 댄스> 초청 강연",
      "문체부 주간 정책지 '공감' 인터뷰",
      "<코로나 시대, 브레이킹으로 자기 계발을 하다>",
      "2021 전북콘텐츠융합진흥원 크리에이터 선정",
      "2021 한국콘텐츠진흥원 아이디어 융합팩토리 콘텐츠 크리에이터팀 선정",
      "수원 청소년 힙합 페스티벌 vol.2 심사위원",
      "K-POP WORLD DANCE FESTIVAL CONETST 동상",
      "브레이킹 어린이 뮤지컬 <빨간고양이 피터> 출연",
      "양재 AT센터 <노벨 사이언스> 브레이킹 공연",
      "부산 시티 브레이커즈 vol.2 비걸 준우승",
      "대전대 혜화문화관 코리아비걸크루 공연 ",
      "컨버스 배틀 무브 온라인 VOL.5 2nd place",
      "컨버스 배틀 무브 온라인 VOL.4 2nd place",
      "2007 대한민국 여성 발명품 박람회 공연",
      "2007 코엑스 대한민국 창업대전 시상식 공연",
      "빅뱅 SCHOOL LOOKS CF 광고 촬영",
      "kbs 취재파일4321 <거리에서 세계로: 브레이크 댄스 편> 출연",
    ],
    instagram: "https://www.instagram.com/breakinbee",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: HONEYBEEImage,
  },

  {
    name: "WAANO",
    genre: "PRIVATE",
    class: ["셔플 / KPOP"],
    career: [
      "2025 임영웅 콘서트 ‘리사이틀‘ 댄서",
      "2025 박지현 대구 콘서트 댄서",
      "2024 VALORANT CHAMPIONSHIPS Opening Ceremony",
      "방탄소년단  'BTS WORLD TOUR 'LOVEYOURSELF'  댄서",
      "임영웅 ‘We’re HERO’ 콘서트 댄서",
      "드림콘서트 30th anniversary 젝스키스 강성훈 댄서",
      "H.O.T. 이재원 콘서트 댄서",
      "현 국제실용댄스지도자협회 지도자양성 키즈 강사",
      "전 한림연예예술고등학교 방과후 얼반댄스 강사",
      "전 아뮤즈 코리아 엔터 트레이닝",
      "전 백제예술대학 실용댄스과 코레오 담당교수",
      "가수 ‘오프로드(Offroad)’트레이닝",
      "KDM 아카데미 K-POP, 오디션반 강사",
      "SMTOWN COEX Artium 댄스 트레이너",
      "아이돌 전문 양성소 실용음악학원 오디션 강사",
      "M Music Dance Academy 전문반 강사",
      "SMMA 실용음악학원 오디션 전문 강사",
      "STC 실용음악아카데미 오디션 전문 강사",
      "J&J Dance Studio 강사",
      "GRAVITY Culture Ground 코레오 강사",
      "서울대학교 언어교육원 온라인 외국인특강",
      "ISA 어학원 외국인특강",
      "서울대 언어교육원 외국인특강",
      "CIS 어학원 외국인특강",
      "대한민국 탭댄스 팀 : 탭퍼스 워크샵 무대감독 및 조연출",
      "2011 대학로 아울 댄스 페스티벌 무대감독 및 조연출",
      "2012 대학로 아울 댄스 페스티벌 공연",
      "2013 인천 실내무도 아시안게임 개막식 공연",
      "강원지방경찰청 ‘경찰의 날’ 기념행사 축하공연",
      "골든디스크 시상식 – 크레용팝 댄서 참여",
      "서울특별시 '문화가 있는 날'  공연",
      "2016 TIME TAP Dance Company - 2016파티 게스트쇼",
      "2016 TIME TAP Dance Company - 일본 신주쿠 공연",
    ],
    instagram: "https://www.instagram.com/waanowaano",
    reservation: "http://pf.kakao.com/_xdxcJZn",
    img: WAANOImage,
  },
];
// E ::::: 강사진 ::::: E
